<template>
	<div class="docs-box">

	   	<div class="lmy-map-back lmy-back-long"  onclick="window.history.go(-1)">
           	<i class="iconfont icon-back" >	</i>
        
           	<label>返回</label>
       	</div>
		<div class="docs-home" v-if="answer=='01'">
			<img src="./../../../assets/img/docs/01/01.jpg" />
			<img src="./../../../assets/img/docs/01/02.jpg" />
		</div>
		<div class="docs-home" v-if="answer=='02'">
			<img src="./../../../assets/img/docs/02/04.jpg" />
			<!-- <img src="./../../../assets/img/docs/02/02.jpg" /> -->
		</div>
		<div class="docs-home" v-if="answer=='04'">
			<img src="./../../../assets/img/docs/04/01.jpg" />
			<img src="./../../../assets/img/docs/04/02.jpg" />
		</div>
		<div class="docs-home" v-if="answer=='03'">
			<img src="./../../../assets/img/docs/03/2_01.jpg" />
			<img src="./../../../assets/img/docs/03/2_02.jpg" />
			<img src="./../../../assets/img/docs/03/2_03.jpg" />
			<img src="./../../../assets/img/docs/03/2_04.jpg" />
			<img src="./../../../assets/img/docs/03/2_05.jpg" />
			<img src="./../../../assets/img/docs/03/2_06.jpg" />
		</div>
		<div class="docs-home" v-if="answer=='05'">
			<img src="./../../../assets/img/docs/05/01.jpg" />
			<img src="./../../../assets/img/docs/05/02.jpg" />
			<img src="./../../../assets/img/docs/05/03.jpg" />
			<img src="./../../../assets/img/docs/05/04.jpg" />
		</div>
	</div>
</template>
<script>
	export default{
		name:'docs-answer',
		data(){
			return{
				answer:this.$route.query.answer||'01'
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/usr/docs/answer.vue